/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */

import React, { Dispatch, useEffect, useState } from 'react'
import { useAdobeAnalytics } from '@hooks/useAdobeAnalytics'
import { Button } from '@ds.e/react/lib'
import LocalStorage from '@storage/browser/LocalStorage'
import Greeting from '@molecules/Greeting/Greeting'

import { ONBOARDING_WRAPPER_LABELS } from '@constants/onboardingWrapperLabels' 
import { useError } from '@hooks/useError';


import '@ds.e/scss/lib/Button.css'
import './Onboarding.scss'
import IMAGEONBOARDING from 'assets/images/onboarding-mobile.png'
import ICON01ONBOARDING from '@assetsSVG/icon-onboarding-01.svg'
import ICON02ONBOARDING from '@assetsSVG/icon-onboarding-02.svg'


export interface OnboardingWrapperProps {
  isShowed: Dispatch<React.SetStateAction<boolean>>
}

const OnboardingWrapper = ({ isShowed }: OnboardingWrapperProps) => {
  const { registerViewData } = useAdobeAnalytics();
  useEffect(() => {
    registerViewData('Inicio - DP', 'page')
  }, []);

  const [showSticky, setShowSticky] = useState(false)
  const { errorHandler } = useError();
  useEffect(() => {
    const handleScroll = () => {
      try {
        const windowHeight = window.innerHeight;
        const stickyContent: any = document.getElementById( 'sticky-content' )
        const stickyFooter: any = document.getElementById( 'sticky-footer' )
        if ( stickyContent.offsetHeight + stickyFooter.offsetHeight <= windowHeight ) {
          setShowSticky( true )
        } else {
          setShowSticky( false )
        }
      } catch (error) {
        errorHandler(error);
      }
    };
    window.addEventListener("scroll", handleScroll );
    window.addEventListener("resize", handleScroll );
    handleScroll()
  }, [])

  const storage = new LocalStorage()
  const closeOnboarding = () => {
    storage.set(
      'viewOnBoarding' , 
      'true'
    )
    isShowed(false)
  }

  return (
    <div style={{ height: '100vh', backgroundColor: '#ffffff' }}>
      <div className="onboarding-container" id="sticky-content">
        <div className="onboarding-background">
          <img alt="" src={IMAGEONBOARDING} />
          <div className="onboarding-icon icon-1">
            <img src={ICON01ONBOARDING} alt="" />
          </div>
          <div className="onboarding-icon icon-2">
            <img src={ICON01ONBOARDING} alt="" />
          </div>
          <div className="onboarding-icon icon-3">
            <img src={ICON02ONBOARDING} alt="" />
          </div>
        </div>

        <div className="greeting-container-box">
          <div className="greeting-container-text">
            <Greeting
              greetingContainerClassName="greeting-container"
              titleContainerClassName="greeting-title-container"
              subTitleContainerClassName="subtitle-container"
              title={ONBOARDING_WRAPPER_LABELS.GREETING}
              subtitle=""
            >
              <>
              </>
            </Greeting>
            <p className="greeting-paragraph">{ONBOARDING_WRAPPER_LABELS.PARAGRAPH}</p>

            <div className="btnContinue">
              <Button
                buttonType="fill"
                className="onboarding-button"
                label={ONBOARDING_WRAPPER_LABELS.BTNCONFIRM}
                onClick={closeOnboarding}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`sticky-footer ${showSticky ? 'visible' : ''} `} id="sticky-footer">
        <Button
          buttonType="fill"
          className="onboarding-button"
          label={ONBOARDING_WRAPPER_LABELS.BTNCONFIRM}
          onClick={closeOnboarding}
        />
      </div>
    </div>
  )
}

export default OnboardingWrapper
